import { ROUTES } from '@/constants'

export const PRIMARY_DONATION_NAV_ROUTE = {
  DONATE_NEAR_YOU: 'DONATE_NEAR_YOU',
  SEARCH_BY_DONOR_CENTERS: 'SEARCH_BY_DONOR_CENTERS',
  SEARCH_BY_ZIP_CODE: 'SEARCH_BY_ZIP_CODE',
  SEARCH_BY_CITY: 'SEARCH_BY_CITY',
  SEARCH_BY_SPONSOR: 'SEARCH_BY_SPONSOR',
}

const ROUTE_META = {
  [PRIMARY_DONATION_NAV_ROUTE.DONATE_NEAR_YOU]: {
    id: 'donate-near-you',
    label: 'Donate Near You',
    path: ROUTES.DONATE_NEAR_YOU,
  },
  [PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_DONOR_CENTERS]: {
    id: 'search-by-donor-centers',
    label: 'Search By Donor Centers',
    path: ROUTES.DONATE_DONOR_CENTERS,
  },
  [PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_ZIP_CODE]: {
    id: 'search-by-zip-code',
    label: 'Search By Zip Code',
    path: ROUTES.DONATE_ZIP_CODE,
  },
  [PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_CITY]: {
    id: 'search-by-city',
    label: 'Search By City',
    path: ROUTES.DONATE_CITY,
  },
  [PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_SPONSOR]: {
    id: 'search-by-sponsor',
    label: 'Search By Sponsor',
    path: ROUTES.DONATE_SPONSOR,
  },
}

const LEGACY_NAV_ITEMS = [
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.DONATE_NEAR_YOU],
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_DONOR_CENTERS],
]

function normalizeSlot(value) {
  if (value == null || value === '') return null
  return ROUTE_META[value] ? value : null
}

/**
 * @param {Record<string, unknown> | null | undefined} tenantInnerData – inner `data` from portal-config
 */
export function getPrimaryDonationNavItems(tenantInnerData) {
  if (!tenantInnerData) return LEGACY_NAV_ITEMS
  const s1 = normalizeSlot(tenantInnerData.portal_primary_nav_slot_1)
  const s2 = normalizeSlot(tenantInnerData.portal_primary_nav_slot_2)
  const s3 = normalizeSlot(tenantInnerData.portal_primary_nav_slot_3)
  const s4 = normalizeSlot(tenantInnerData.portal_primary_nav_slot_4)
  const s5 = normalizeSlot(tenantInnerData.portal_primary_nav_slot_5)
  if (!s1 && !s2 && !s3 && !s4 && !s5) return []
  const items = []
  if (s1) items.push(ROUTE_META[s1])
  if (s2) items.push(ROUTE_META[s2])
  if (s3) items.push(ROUTE_META[s3])
  if (s4) items.push(ROUTE_META[s4])
  if (s5) items.push(ROUTE_META[s5])
  return items
}

const PRIMARY_SCHEDULING_PATH_PREFIXES = [
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.DONATE_NEAR_YOU].path,
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_DONOR_CENTERS].path,
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_ZIP_CODE].path,
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_CITY].path,
  ROUTE_META[PRIMARY_DONATION_NAV_ROUTE.SEARCH_BY_SPONSOR].path,
]

/**
 * Donate Near You, Search by Donor Centers, and Search by Zip Code flows (including nested routes).
 * @param {string | undefined} pathname
 */
export function isPrimaryDonationSchedulingPath(pathname) {
  if (typeof pathname !== 'string') return false
  return PRIMARY_SCHEDULING_PATH_PREFIXES.some(
    base => pathname === base || pathname.startsWith(`${base}/`)
  )
}

/**
 * @param {Record<string, unknown> | null | undefined} tenantInnerData
 * @returns {string | null} First configured nav path, or null when tenant has no primary scheduling routes
 */
export function getDefaultDonatePath(tenantInnerData) {
  const items = getPrimaryDonationNavItems(tenantInnerData)
  if (items.length === 0) return null
  return items[0]?.path ?? ROUTES.DONATE_NEAR_YOU
}
